import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/header';
import logo from '../image/logo.png';
import '../styles/inicio.css';
import { useLanguage } from '../context/LanguageContext';

const Inicio = () => {
  const { language } = useLanguage();

  const content = {
    es: {
      eyebrow: 'Energia natural desde la Amazonia ecuatoriana',
      heroTitle: 'El superalimento amazonico que transforma tu bienestar',
      hero: 'Descubre el poder del Sacha Inchi y sus increíbles beneficios para tu bienestar.',
      ctaProducts: 'Ver productos',
      ctaContact: 'Hablar con el equipo',
      title: 'Nuestra Historia',
      p1: 'Sainza es una empresa comprometida con la seguridad alimentaria y el bienestar. Surge de la firme convicción de contribuir al mejoramiento nutricional y fomentar la agricultura sostenible.',
      p2: 'Nuestro producto estrella es el Sacha Inchi, un superalimento rico en Omega-3, antioxidantes y proteínas, con múltiples beneficios para la salud cardiovascular, cerebral, la piel y el cabello.',
      p3: 'Cultivado en el Alto Nangaritza con métodos sostenibles, garantizamos calidad, identidad cultural y desarrollo económico para nuestra comunidad.',
      tags: ['Omega 3', 'Produccion local', 'Bienestar diario'],
      stats: [
        { value: '100%', label: 'Natural' },
        { value: '3x', label: 'Mas Omega 3' },
        { value: 'Origen', label: 'Alto Nangaritza' }
      ]
    },
    en: {
      eyebrow: 'Natural energy from the Ecuadorian Amazon',
      heroTitle: 'The Amazon superfood designed to elevate your wellness',
      hero: 'Discover the power of Sacha Inchi and its incredible benefits for your wellness.',
      ctaProducts: 'View products',
      ctaContact: 'Talk to our team',
      title: 'Our Story',
      p1: 'Sainza is a company committed to food security and wellness. It was created with the conviction of improving nutrition and promoting sustainable agriculture.',
      p2: 'Our flagship product is Sacha Inchi, a superfood rich in Omega-3, antioxidants, and protein, with many benefits for cardiovascular health, brain function, skin, and hair.',
      p3: 'Grown in Alto Nangaritza with sustainable methods, we guarantee quality, cultural identity, and economic development for our community.',
      tags: ['Omega 3', 'Local production', 'Daily wellness'],
      stats: [
        { value: '100%', label: 'Natural' },
        { value: '3x', label: 'More Omega 3' },
        { value: 'Origin', label: 'Alto Nangaritza' }
      ]
    }
  };

  const t = content[language];

  return (
    <div className="inicio-container page-shell">
      <Header />
      <main className="inicio-main-content">
        <section className="hero-section">
          <div className="hero-copy">
            <p className="hero-eyebrow">{t.eyebrow}</p>
            <h1 className="hero-title">{t.heroTitle}</h1>
            <p className="hero-subtitle">{t.hero}</p>

            <div className="hero-actions">
              <Link to="/productos" className="hero-btn hero-btn-primary">{t.ctaProducts}</Link>
              <Link to="/contacto" className="hero-btn hero-btn-secondary">{t.ctaContact}</Link>
            </div>

            <div className="hero-metrics">
              {t.stats.map((item) => (
                <div key={item.label} className="metric-pill">
                  <strong>{item.value}</strong>
                  <span>{item.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="hero-media-column">
            <div className="video-container">
              <video
                className="background-video"
                src={require('../image/vid1.mp4')}
                autoPlay
                loop
                muted
                playsInline
              />
            </div>
            <div className="brand-float">
              <img src={logo} alt="Sainza Logo" className="large-logo" />
            </div>
          </div>
        </section>

        <section className="story-section">
          <div className="text-container">
            <h2 className="section-title">{t.title}</h2>
            <p className="info">{t.p1}</p>
            <p className="info">{t.p2}</p>
            <p className="info">{t.p3}</p>
            <div className="hero-tags">
              {t.tags.map((tag) => (
                <span key={tag}>{tag}</span>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Inicio;
